import { useEffect } from "react";
import { supabase } from "../lib/SupabaseClient";
import { useNavigate } from "react-router-dom";

export default function CandidateGuard({ children }: { children: React.ReactNode }) {
    const navigate = useNavigate();

    useEffect(() => {
        async function validateCandidate() {
            // ✅ Dev-mode bypass (skip Supabase login checks)
            if (import.meta.env.MODE === "development") {
                console.warn("⚠️ CandidateGuard bypass active (dev only)");
                return; // allow access directly
            }

            // 🔒 Normal behavior in production
            const { data: { user } } = await supabase.auth.getUser();
            if (!user) {
                navigate("/candidate/login");
                return;
            }

            // Check candidate record in DB
            const { data, error } = await supabase
                .from("candidates")
                .select("id, candidateassignments(test_id)")
                .or(`email.eq.${user.email},phone.eq.${user.phone}`);

            if (error || !data || data.length === 0) {
                navigate("/candidate/unauthorized");
                return;
            }

            const assignment = data[0].candidateassignments?.[0];
            if (!assignment) {
                navigate("/candidate/notest");
                return;
            }

            // If assignment exists → let CandidateTestPage handle rendering
        }

        validateCandidate();
    }, [navigate]);

    return <>{children}</>;
}
